import GeneralHeader from "src/components/Sections/General/GeneralHeader/GeneralHeader";
import SendMessageForm from "src/components/SendMessageForm/SendMessageForm";
import ContactsHome from "src/components/Sections/HomePage/AboutUsHome/components/ContactsHome/ContactsHome";

const Contacts = () => (
    <>
      <GeneralHeader />
      <section className="bg-gray-100 px-4">
        <div className="container mx-auto py-10">
          <ContactsHome />
          <div className="bg-white px-8 lg:px-20 py-12 mt-8">
            <SendMessageForm />
          </div>
        </div>
      </section>
    </>
  );

export default Contacts;